import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class FileService {

    constructor() {}

    /**
     * This method can be used for downloading any file with the click on a file.
     * @param {*} data file data
     * @param {*} fileName name for saving file
     */
    public downloadFile(data, fileName) {
      if (data) {
        const url = window.URL.createObjectURL(data);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      }
    }

}